"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../../");

var s = _interopRequireWildcard(require("./styles"));

var _selectionType = _interopRequireDefault(require("./selectionType"));

function hasOnlyIcon(children) {
  if (_react.default.Children.count(children) !== 1) {
    return false;
  }

  var child = _react.default.Children.toArray(children)[0];

  return child.type === _.Icon;
}

function renderNotification(notification, theme) {
  if (!notification.count) {
    return null;
  }

  var count = notification.count,
      className = notification.className,
      otherProps = (0, _objectWithoutProperties2.default)(notification, ["count", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(className, s.notification(theme, count))
  }, otherProps));
}

function DarkAccentButton(props) {
  var children = props.children,
      selected = props.selected,
      selectionType = props.selectionType,
      disabled = props.disabled,
      theme = props.theme,
      className = props.className,
      notification = props.notification,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["children", "selected", "selectionType", "disabled", "theme", "className", "notification"]);
  var rounded = selectionType === _selectionType.default.Normal && hasOnlyIcon(children);
  return _react.default.createElement("button", (0, _extends2.default)({
    disabled: disabled,
    className: (0, _classnames.default)(s.root(theme, rounded, {
      selected: selected,
      type: selectionType
    }, disabled), className)
  }, otherProps), children, renderNotification(notification, theme));
}

DarkAccentButton.defaultProps = {
  selected: false,
  selectionType: _selectionType.default.Normal,
  notification: {
    count: 0
  }
};
DarkAccentButton.propTypes = {
  selected: _propTypes.default.bool,
  selectionType: _propTypes.default.oneOf(Object.values(_selectionType.default)),
  notification: _propTypes.default.shape({
    count: _propTypes.default.string,
    className: _propTypes.default.string
  })
};
DarkAccentButton.selectionType = _selectionType.default;

var _default = (0, _emotionTheming.withTheme)(DarkAccentButton);

exports.default = _default;